// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["js/bundle"], function() { return __webpack_require__("./resources/assets/js/sp/pages/lp/2/view.js"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
